export const FOUND_SOURCES = Object.freeze([
  'Рассылка холодная', 'Рассылка по нашей базе', 'Готовая база', 'Парсер', 'Заявка',
  'Threads', 'Reddit', 'Behance', 'Органика', 'Реферал', 'Другое',
]);

export const CONNECTION_TYPES = Object.freeze([
  'Email', 'Instagram', 'TikTok', 'Threads', 'X', 'Reply', 'Telegram', 'WhatsApp', 'Facebook',
]);

export const LEGACY_CONNECTION_TYPES = Object.freeze(['Telegram/WhatsApp']);

export const FOUNDSOURCE_ALIASES = Object.freeze({
  'рассылка ефим': 'Рассылка холодная',
  'саша': 'Готовая база',
  'threads vandraw': 'Threads',
});

const LISTS = { foundSource: FOUND_SOURCES, connectionType: CONNECTION_TYPES };

const fold = (s) => s.trim().replace(/\s+/g, ' ').toLowerCase();

export function isLeadOption(kind, v) {
  return typeof v === 'string' && LISTS[kind]?.includes(v) === true;
}

export function normalizeLeadOption(kind, raw) {
  const list = LISTS[kind];
  if (!list || typeof raw !== 'string') return null;
  const k = fold(raw);
  if (k === '') return null;
  const hit = [...list, ...(kind === 'connectionType' ? LEGACY_CONNECTION_TYPES : [])].find((x) => x.toLowerCase() === k);
  if (hit) return hit;
  if (kind === 'foundSource') return FOUNDSOURCE_ALIASES[k] ?? null;
  return null;
}
